import React, { Component } from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  Avatar,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import {
  Inventory2,
  Category,
  NotificationsActive,
  AutoGraph,
  Sync,
  ExpandMore,
  CheckCircle,
  ArrowForward,
  Layers,
  WarningAmber,
  PlaylistAddCheck,
  TrendingDown,
  Storefront
} from '@mui/icons-material';

class FazPedidoModuloEstoquePage extends Component {
  render() {
    return (
      <Box sx={{ bgcolor: '#ffffff', color: '#0f172a', minHeight: '100vh', pb: 10 }}>

        {/* 1. HERO SECTION */}
        <Box
          sx={{
            bgcolor: '#ffffff',
            pt: { xs: 8, md: 12 },
            pb: { xs: 8, md: 10 },
            borderBottom: '1px solid #f1f5f9'
          }}
        >
          <Container maxWidth="lg">
            <Grid container spacing={4} alignItems="center">
              <Grid size={{ xs: 12, md: 7 }}>
                <Chip
                  label="Tecnologia FazPedido"
                  sx={{
                    bgcolor: 'rgba(124, 58, 237, 0.1)',
                    color: '#7c3aed',
                    fontWeight: 700,
                    mb: 2,
                    px: 1
                  }}
                />
                <Typography
                  variant="h2"
                  component="h1"
                  sx={{
                    fontWeight: 800,
                    fontSize: { xs: '2.2rem', md: '3.4rem' },
                    lineHeight: 1.2,
                    color: '#0f172a',
                    mb: 2
                  }}
                >
                  Controle de Estoque & Grades{' '}
                  <Box component="span" sx={{ color: '#7c3aed' }}>
                    sem complicações
                  </Box>
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ color: '#64748b', fontWeight: 400, mb: 4, lineHeight: 1.6 }}
                >
                  Gerencie variações de produtos (tamanhos, cores, sabores e adicionais) e monitore seu estoque em tempo real. Baixa automática a cada venda realizada no delivery, PDV ou mesas.
                </Typography>

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <Button
                    variant="contained"
                    size="large"
                    endIcon={<ArrowForward />}
                    sx={{
                      bgcolor: '#7c3aed',
                      '&:hover': { bgcolor: '#6d28d9' },
                      px: 4,
                      py: 1.8,
                      fontSize: '1.1rem',
                      fontWeight: 700,
                      borderRadius: '12px',
                      textTransform: 'none',
                      boxShadow: '0 10px 25px -5px rgba(124, 58, 237, 0.3)'
                    }}
                  >
                    Testar Estoque FazPedido
                  </Button>
                  <Button
                    variant="outlined"
                    size="large"
                    sx={{
                      color: '#7c3aed',
                      borderColor: '#7c3aed',
                      '&:hover': { borderColor: '#6d28d9', bgcolor: 'rgba(124, 58, 237, 0.04)' },
                      px: 3,
                      py: 1.8,
                      borderRadius: '12px',
                      textTransform: 'none',
                      fontWeight: 700
                    }}
                  >
                    Ver Demonstração
                  </Button>
                </Stack>
              </Grid>

              {/* MOCKUP VISUAL ESTOQUE */}
              <Grid size={{ xs: 12, md: 5 }}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 4,
                    bgcolor: '#f8fafc',
                    borderRadius: '24px',
                    border: '2px solid #7c3aed',
                    boxShadow: '0 20px 30px -10px rgba(124, 58, 237, 0.15)'
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <Avatar sx={{ bgcolor: '#7c3aed', mr: 2, width: 48, height: 48 }}>
                      <Inventory2 />
                    </Avatar>
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a' }}>
                        Painel de Estoque
                      </Typography>
                      <Typography variant="caption" sx={{ color: '#64748b' }}>
                        Sincronizado com PDV & Loja Online
                      </Typography>
                    </Box>
                  </Box>

                  <Card variant="outlined" sx={{ mb: 2, borderRadius: '14px', borderColor: '#e2e8f0' }}>
                    <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                          Combo Família (Grade P/M/G)
                        </Typography>
                        <Chip label="Estoque Baixo" color="warning" size="small" sx={{ fontWeight: 700 }} />
                      </Stack>
                      <Typography variant="h6" sx={{ color: '#7c3aed', fontWeight: 800, mt: 1 }}>
                        Restam 4 unidades
                      </Typography>
                      <Typography variant="caption" sx={{ color: '#64748b' }}>
                        Baixa automática efetuada há 2 minutos
                      </Typography>
                    </CardContent>
                  </Card>

                  <Box sx={{ bgcolor: '#ffffff', p: 2, borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <CheckCircle sx={{ color: '#7c3aed', fontSize: 20 }} />
                      <Typography variant="body2" sx={{ fontWeight: 600, color: '#334155' }}>
                        Zero rupturas surpresa com alertas inteligentes.
                      </Typography>
                    </Stack>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </Box>

        {/* 2. OS 4 PILARES DO ESTOQUE */}
        <Container maxWidth="lg" sx={{ mt: 10 }}>
          <Grid container spacing={3}>
            {[
              {
                num: '01',
                title: 'Gestão de Grades & Variações',
                desc: 'Cadastre produtos com múltiplas variações de tamanho, cor, sabores e adicionais sem duplicar cadastros.',
                icon: <Layers sx={{ color: '#7c3aed', fontSize: 32 }} />
              },
              {
                num: '02',
                title: 'Baixa Automática por Venda',
                desc: 'Cada pedido aprovado no delivery, mesa ou balcão abate instantaneamente a quantidade do estoque.',
                icon: <Sync sx={{ color: '#7c3aed', fontSize: 32 }} />
              },
              {
                num: '03',
                title: 'Alertas de Ruptura',
                desc: 'Aviso prévio quando itens essenciais estiverem acabando para evitar perder vendas por falta de produto.',
                icon: <NotificationsActive sx={{ color: '#7c3aed', fontSize: 32 }} />
              },
              {
                num: '04',
                title: 'Relatórios de Giro',
                desc: 'Identifique quais produtos têm maior saída e otimice suas compras com fornecedores.',
                icon: <AutoGraph sx={{ color: '#7c3aed', fontSize: 32 }} />
              }
            ].map((pillar, idx) => (
              <Grid size={{ xs: 12, sm: 6, md: 3 }} key={idx}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    height: '100%',
                    borderRadius: '16px',
                    bgcolor: '#f8fafc',
                    border: '1px solid #e2e8f0',
                    position: 'relative',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      borderColor: '#7c3aed',
                      transform: 'translateY(-4px)',
                      boxShadow: '0 12px 20px -5px rgba(124, 58, 237, 0.1)'
                    }
                  }}
                >
                  <Typography variant="h3" sx={{ fontWeight: 900, color: 'rgba(124, 58, 237, 0.2)', position: 'absolute', top: 16, right: 16 }}>
                    {pillar.num}
                  </Typography>
                  <Box sx={{ mb: 2 }}>{pillar.icon}</Box>
                  <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a', mb: 1 }}>
                    {pillar.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#64748b', lineHeight: 1.6 }}>
                    {pillar.desc}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* 3. FUNCIONALIDADES AVANÇADAS DE ESTOQUE */}
        <Container maxWidth="lg" sx={{ mt: 12 }}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 4, md: 6 },
              borderRadius: '24px',
              bgcolor: '#f8fafc',
              border: '1px solid #e2e8f0'
            }}
          >
            <Grid container spacing={4} alignItems="center">
              <Grid size={{ xs: 12, md: 6 }}>
                <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a', mb: 2 }}>
                  Controle total dos insumos e produtos do seu estabelecimento
                </Typography>
                <Typography variant="body1" sx={{ color: '#475569', mb: 3 }}>
                  Evite desperdícios e tenha precisão cirúrgica no que entra e sai do seu negócio com as ferramentas integradas do FazPedido.
                </Typography>
                <Typography variant="body2" sx={{ color: '#64748b', mb: 4 }}>
                  Organize categorias, defina estoques mínimos e mantenha o cardápio digital atualizado em tempo real (se um item acaba, ele pode ser pausado automaticamente).
                </Typography>

                <Grid container spacing={2}>
                  {[
                    { title: 'Pausa Automática', desc: 'Produtos esgotados saem do ar no cardápio digital para evitar pedidos frustrados.', icon: <WarningAmber /> },
                    { title: 'Controle de Lotes', desc: 'Acompanhe entradas e saídas com facilidade através de histórico detalhado.', icon: <PlaylistAddCheck /> },
                    { title: 'Múltiplas Variações', desc: 'Perfeito para roupas, calçados, pizzas, combos e porções customizáveis.', icon: <Layers /> },
                    { title: 'Sincronização PDV', desc: 'Vendeu no balcão? O estoque digital é atualizado instantaneamente.', icon: <Sync /> }
                  ].map((item, i) => (
                    <Grid size={{ xs: 12, sm: 6 }} key={i}>
                      <Stack direction="row" spacing={1.5} alignItems="flex-start">
                        <Avatar sx={{ bgcolor: '#7c3aed', width: 36, height: 36, mt: 0.5 }}>
                          {React.cloneElement(item.icon, { sx: { fontSize: 20, color: '#fff' } })}
                        </Avatar>
                        <Box>
                          <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#0f172a' }}>
                            {item.title}
                          </Typography>
                          <Typography variant="caption" sx={{ color: '#64748b', display: 'block', lineHeight: 1.4 }}>
                            {item.desc}
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>
                  ))}
                </Grid>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <Box
                  sx={{
                    bgcolor: '#ffffff',
                    p: 4,
                    borderRadius: '20px',
                    border: '2px solid #7c3aed',
                    boxShadow: '0 15px 30px -10px rgba(124, 58, 237, 0.12)'
                  }}
                >
                  <Typography variant="h5" sx={{ fontWeight: 800, color: '#7c3aed', mb: 2 }}>
                    Benefícios para a Gestão
                  </Typography>
                  <List disablePadding>
                    <ListItem sx={{ px: 0 }}>
                      <ListItemIcon><CheckCircle sx={{ color: '#7c3aed' }} /></ListItemIcon>
                      <ListItemText primary="Fim das divergências entre o estoque físico e o sistema" />
                    </ListItem>
                    <ListItem sx={{ px: 0 }}>
                      <ListItemIcon><CheckCircle sx={{ color: '#7c3aed' }} /></ListItemIcon>
                      <ListItemText primary="Redução drástica de perdas e desperdícios" />
                    </ListItem>
                    <ListItem sx={{ px: 0 }}>
                      <ListItemIcon><CheckCircle sx={{ color: '#7c3aed' }} /></ListItemIcon>
                      <ListItemText primary="Agilidade na reposição e compras com base em dados reais" />
                    </ListItem>
                    <ListItem sx={{ px: 0 }}>
                      <ListItemIcon><CheckCircle sx={{ color: '#7c3aed' }} /></ListItemIcon>
                      <ListItemText primary="Experiência de compra impecável para o cliente final" />
                    </ListItem>
                  </List>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </Container>

        {/* 4. FAQ / PERGUNTAS FREQUENTES */}
        <Container maxWidth="md" sx={{ mt: 10 }}>
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography variant="overline" sx={{ color: '#7c3aed', fontWeight: 800, letterSpacing: 1.5 }}>
              DÚVIDAS FREQUENTES
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a' }}>
              Perguntas sobre o Controle de Estoque
            </Typography>
          </Box>

          {[
            {
              q: '1. Como funcionam as grades de produtos?',
              a: 'As grades permitem que você agrupe variações de um mesmo produto (como Tamanho P, M, G ou Cores e Sabores) facilitando tanto o cadastro quanto a visualização do estoque disponível para cada variação específica.'
            },
            {
              q: '2. O estoque é atualizado sozinho quando ocorre uma venda?',
              a: 'Sim! Cada pedido finalizado no delivery, balcão ou mesas dá baixa automática imediata nos itens correspondentes do estoque.'
            },
            {
              q: '3. Posso definir avisos para quando um produto estiver acabando?',
              a: 'Com certeza. Você pode configurar limites mínimos de estoque para receber alertas visuais e antecipar suas compras.'
            },
            {
              q: '4. Se um produto esgotar, ele some do cardápio digital?',
              a: 'Sim, o FazPedido conta com a opção de pausa automática, evitando que clientes comprem itens que estão em falta no estabelecimento.'
            }
          ].map((faq, fIdx) => (
            <Accordion
              key={fIdx}
              elevation={0}
              sx={{
                mb: 1.5,
                border: '1px solid #e2e8f0',
                borderRadius: '12px !important',
                '&:before': { display: 'none' },
                '&.Mui-expanded': { border: '1px solid #7c3aed' }
              }}
            >
              <AccordionSummary expandIcon={<ExpandMore sx={{ color: '#7c3aed' }} />}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#0f172a' }}>
                  {faq.q}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2" sx={{ color: '#64748b', lineHeight: 1.7 }}>
                  {faq.a}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Container>

        {/* 5. BANNER FINAL DE CONVERSÃO */}
        <Container maxWidth="lg" sx={{ mt: 10 }}>
          <Paper
            elevation={0}
            sx={{
              bgcolor: '#ffffff',
              borderRadius: '28px',
              p: { xs: 5, md: 8 },
              textAlign: 'center',
              border: '3px solid #7c3aed',
              boxShadow: '0 20px 40px -15px rgba(124, 58, 237, 0.25)'
            }}
          >
            <Typography variant="h3" sx={{ fontWeight: 900, color: '#0f172a', mb: 2, fontSize: { xs: '2rem', md: '2.6rem' } }}>
              Tenha controle absoluto do seu estoque hoje mesmo!
            </Typography>
            <Typography variant="h6" sx={{ color: '#64748b', mb: 4, maxW: '650px', mx: 'auto', fontWeight: 400 }}>
              Elimine rupturas, gerencie grades com facilidade e automatize suas baixas com o FazPedido.
            </Typography>
            <Button
              variant="contained"
              size="large"
              endIcon={<ArrowForward />}
              sx={{
                bgcolor: '#7c3aed',
                color: '#ffffff',
                '&:hover': { bgcolor: '#6d28d9' },
                px: 5,
                py: 2,
                fontSize: '1.2rem',
                fontWeight: 800,
                borderRadius: '14px',
                textTransform: 'none',
                boxShadow: '0 10px 25px -5px rgba(124, 58, 237, 0.4)'
              }}
            >
              Falar com um Especialista
            </Button>
          </Paper>
        </Container>

      </Box>
    );
  }
}

export default FazPedidoModuloEstoquePage;